"use strict";

exports.__esModule = true;
var _LogbookPanelElement = require("./LogbookPanelElement");
Object.keys(_LogbookPanelElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookPanelElement[key]) return;
  exports[key] = _LogbookPanelElement[key];
});
var _LogbookPanelFields = require("./LogbookPanelFields");
Object.keys(_LogbookPanelFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookPanelFields[key]) return;
  exports[key] = _LogbookPanelFields[key];
});
var _LogbookPanelThumbnail = require("./LogbookPanelThumbnail");
Object.keys(_LogbookPanelThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LogbookPanelThumbnail[key]) return;
  exports[key] = _LogbookPanelThumbnail[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});